import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = vnObject

const jsContainer = () => {
  const containers = document.querySelectorAll('.js-container')
  const bodyWidth = document.body.clientWidth
  if (containers.length) {
    ;[...containers].map((container) => {
      container.style.width = `${bodyWidth}px`
      container.style.marginLeft = `calc(${-bodyWidth / 2}px + 50%)`
    })
  }
}

window.addEventListener('resize', jsContainer)
window.addEventListener('load', jsContainer)

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})

$('.vn-excerpt__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.vn-excerpt')

  if (button_parent.hasClass('vn-excerpt--active')) {
    button.html(object.readmore)
  } else {
    button.html(object.readless)
  }

  button_parent.toggleClass('vn-excerpt--active')
})

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  const button = $(this)
  const href = button.attr('data-url')
  const target = button.attr('data-target')

  if (target === '_blank') {
    window.open(href, '_blank');
  }
  else {
    window.location.href = href
  }
})

const hlTitles = document.querySelectorAll('[data-highlight]')
if (hlTitles) {
  ;[...hlTitles].map((el) => {
    const hl = el.getAttribute('data-highlight')
    const replace = el.innerText.replace(
      hl,
      `<span class="vn-primary-color">${hl}</span>`
    )
    el.innerHTML = replace
  })
}

const goTop = document.querySelector('.go-top--desktop')
window.addEventListener('scroll', function () {

})

$('.vn-button').on('click', function () {
  const $this = $(this)
  $this.addClass('animate')
  setTimeout(function () {
    $this.removeClass('animate')
  }, 700)
})

$('.js-mouse').on('click', function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $(".entry-content").offset().top
  }, 200);
})

$('.js-achiev-mouse').on('click', function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $(".single-ach__top").offset().top
  }, 200);
})

$('.js-rec-mouse').on('click', function () {
  $([document.documentElement, document.body]).animate({
    scrollTop: $(".feed-job-offer").offset().top
  }, 200);
})
